import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spinner, Alert, Container } from 'react-bootstrap';
import './index.css'; 
import atendimentosService from '../../api/atendimentosService';
import { useAuth } from '../../contexts/auth-context';

const Home = () => {
  const { user } = useAuth();
  const [atendimentos, setAtendimentos] = useState({
    hoje: null,
    semana: null,
    mes: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAtendimentos = async () => {
      try {
        setLoading(true);
        setError('');
        const responseHoje = await atendimentosService.listarPorDia(user.profissionalId);
        const responseSemana = await atendimentosService.listarPorSemana(user.profissionalId);
        const responseMes = await atendimentosService.listarPorMes(user.profissionalId);

        setAtendimentos({
          hoje: responseHoje.quantidade,
          semana: responseSemana.quantidade,// dataSemana.data.count,
          mes: responseMes.quantidade, //dataMes.data.count,
        });

        setLoading(false);
      } catch (err) {
        console.error('Erro ao buscar atendimentos:', err);
        setError('Não foi possível carregar os dados dos atendimentos.');
        setLoading(false);
      }
    };

    fetchAtendimentos();
  }, []);

  const getHeaderColor = (tipo) => {
    switch (tipo) {
      case 'Hoje':
        return '#28a745'; // Verde
      case 'Semana':
        return '#007bff'; // Azul
      case 'Mês':
        return '#ffc107'; // Laranja
      default:
        return '#6c757d'; // Cor padrão (cinza)
    }
  };

  return (
    <Container className="mt-4">
        <Card className="shadow-sm">
            <Card.Body>
            <Card.Title className="text-center mb-4">Home</Card.Title>
            <hr></hr>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </Spinner>
                    </div>
                ) : error ? (
                    <Alert variant="danger" className="text-center">
                    {error}
                    </Alert>
                ) : (
                    <Row xs={1} md={3} className="g-4">
                    {/* Card para Hoje */}
                    <Col>
                        <Card className="text-center shadow-sm">
                        <Card.Header style={{ backgroundColor: getHeaderColor('Hoje'), color: 'white' }}>
                            Hoje
                        </Card.Header>
                        <Card.Body>
                            <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                            {atendimentos.hoje}
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </Col>

                    {/* Card para Semana */}
                    <Col>
                        <Card className="text-center shadow-sm">
                        <Card.Header style={{ backgroundColor: getHeaderColor('Semana'), color: 'white' }}>
                            Semana
                        </Card.Header>
                        <Card.Body>
                            <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                            {atendimentos.semana}
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </Col>

                    {/* Card para Mês */}
                    <Col>
                        <Card className="text-center shadow-sm">
                        <Card.Header style={{ backgroundColor: getHeaderColor('Mês'), color: 'white' }}>
                            Mês
                        </Card.Header>
                        <Card.Body>
                            <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                            {atendimentos.mes}
                            </Card.Text>
                        </Card.Body>
                        </Card>
                    </Col>
                    </Row>
                )}
            </Card.Body>
            </Card>
        </Container>
  );
};

export default Home;
